module.exports = __webpack_public_path__ + "img/bg_service_disable.6bf45ce7.png";